import { render, staticRenderFns } from "./CatalogSearchBar.vue?vue&type=template&id=032ab836"
import script from "./CatalogSearchBar.vue?vue&type=script&lang=ts"
export * from "./CatalogSearchBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports